module.exports = __webpack_public_path__ + "img/1478392537.1205eaa0.jpg";